import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from 'actions';

import TagInfo from './TagInfo';

import { Button } from 'react-bootstrap';

class Tag extends PureComponent {
  handleClick = e => {
    if (this.props.onClick) {
      this.props.onClick();
    } else {
      this.props.addTagFilter(this.props.tag);
    }
  };

  getClassName = () => {
    const { tag } = this.props;
    return `Tag ${tag.displayClass}`;
  };

  render() {
    const { tag, showInfoWindow, isOpen, hoverEvents } = this.props;
    let className = this.getClassName();
    return (
      <div
        ref={node => (this.node = node)}
        className={`TagContainer ${tag.displayClass}`}
        {...hoverEvents}
      >
        <Button className={className} onClick={this.handleClick}>
          {tag.name}
        </Button>
        {showInfoWindow && (
          <TagInfo
            closeInfoWindow={this.props.closeInfoWindow}
            parentNode={this.node}
            tag={tag}
            isOpen={isOpen}
          />
        )}
      </div>
    );
  }
}

Tag.propTypes = {
  tag: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    schema: PropTypes.string,
    displayClass: PropTypes.string,
  }).isRequired,
  isDimmed: PropTypes.bool.isRequired,
  showInfoWindow: PropTypes.bool.isRequired,
};

Tag.defaultProps = {
  isDimmed: false,
  showInfoWindow: false,
  hoverEvents: {},
};

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      addTagFilter: actions.addTagFilter,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Tag);



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/Tags/Tag.js